export default "__VITE_ASSET__CcoTBaP0__"